import React, { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';

interface ParallaxImageProps {
  alt: string;
  src?: string;
  className?: string;
  loading?: 'eager' | 'lazy';
  onError?: React.ReactEventHandler<HTMLImageElement>;
  intensity?: number;
}

export const ParallaxImage: React.FC<ParallaxImageProps> = ({ alt, intensity = 24, className = '', ...props }) => {
  const imageRef = useRef<HTMLImageElement>(null);
  const reduceMotion = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: imageRef,
    offset: ['start end', 'end start'],
  });
  const y = useTransform(scrollYProgress, [0, 1], reduceMotion ? [0, 0] : [intensity, -intensity]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], reduceMotion ? [1, 1, 1] : [1.06, 1.1, 1.06]);

  return (
    <motion.img
      ref={imageRef}
      {...props}
      alt={alt}
      style={{ y, scale }}
      whileHover={reduceMotion ? undefined : { scale: 1.14 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className={`h-full w-full object-cover ${className}`}
    />
  );
};
